import { Component, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { RevertReservationsStatusService } from 'OpsCenter/merchants/revert-status/revert-reservations-status.service';

@Component({
  selector: 'app-revert-reservations-status',
  template: require('./revert-reservations-status.component.html'),
})
export class RevertReservationsStatusComponent {
  email: string = null;
  fileToUpload: File = null;
  responseMessages: string[] = [];
  isLoading = false;

  @ViewChild('fileInput', {static: false})
  private fileInput: HTMLInputElement;

  constructor(
    private revertStatusService: RevertReservationsStatusService,
    private notificationService: ToastrService
  ) {}

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  uploadFile() {
    if (this.isLoading) {
      return;
    }

    this.enableLoading();
    this.responseMessages = [];
    this.revertStatusService
      .uploadFile(this.email, this.fileToUpload)
      .subscribe(
        () => this.handleUploadSuccess(),
        res => this.handleUploadError(res)
      );
  }

  private handleUploadSuccess() {
    this.notificationService.success(
      `The file will be processed and you will receive an email with the result of the operation`
    );
    this.clearForm();
    this.disableLoading();
  }

  private handleUploadError(res) {
    if (res.status === 404) {
      this.responseMessages = ['Resource not found'];
    } else if (res.error && res.error.errors) {
      this.responseMessages = res.error.errors.map(error => error.message);
    } else if (res.error && res.error.message) {
      this.responseMessages = [res.error.message];
    } else {
      this.responseMessages = ['An unexpected error occurred. Please try again.'];
    }
    this.notificationService.error(
      `There were errors processing the file. Please review and fix them before trying again`
    );
    this.disableLoading();
  }

  private clearForm() {
    this.email = null;
    this.fileToUpload = null;
    this.fileInput.value = '';
  }

  private enableLoading() {
    this.isLoading = true;
  }

  private disableLoading() {
    this.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/revert-status/revert-reservations-status.component.ts